import * as React from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { ImageUploadModal } from '../../../../../components/ImageUploadModal'
import { observer } from 'mobx-react'
import { SmartImage } from '../../../../../components/SmartImage'
import { CreateProduct, CreateChildProduct } from '../ProductStore'

interface State {
  isBiggerImageModalOpen: boolean
  showImageUploadModal: boolean
}

interface Props {
  product: CreateProduct | CreateChildProduct // This can be either a parent product or child product
  className?: string
  imageStyle?: React.CSSProperties
  imageWrapperStyle?: React.CSSProperties
  iconWrapperStyle?: React.CSSProperties
  iconStyle?: React.CSSProperties
}

@observer
export class UploadImageSection extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isBiggerImageModalOpen: false,
      showImageUploadModal: false,
    }
  }

  removeThumbnailPhoto = (product: any): void => {
    if (window.confirm('Are you sure you want to delete this photo?')) {
      product.setImageUrl(null)
      this.setState({ isBiggerImageModalOpen: false })
    }
  }

  thumbnailStyle = {
    height: '100%',
    width: '100%',
    borderRadius: 5,
    fontSize: '2.3rem',
    color: 'grey',
    cursor: 'pointer',
  }

  render() {
    const { product, iconStyle, imageStyle } = this.props
    const isDeleted =
      product instanceof CreateProduct ? product.isDeleted : product.parentProduct.isDeleted

    return (
      <>
        <div className='card mb-4'>
          <div className='card-header d-flex'>
            <div style={{ flexGrow: 1 }}>Image</div>
            {!isDeleted && (
              <a
                data-tip
                data-for='thumbnail-photo'
                onClick={() => this.setState({ showImageUploadModal: true })}
              >
                {product.imageUrl ? 'Update' : 'Upload'}
              </a>
            )}
          </div>
          <div className='card-body'>
            {product.imageUrl ? (
              <>
                <div onClick={() => this.setState({ isBiggerImageModalOpen: true })}>
                  <SmartImage src={product.imageUrl} width={250} />
                </div>

                {!isDeleted && (
                  <div className='text-right mt-2'>
                    <a onClick={() => this.removeThumbnailPhoto(product)}>Remove</a>
                  </div>
                )}

                <Modal
                  isOpen={this.state.isBiggerImageModalOpen}
                  toggle={() => this.setState({ isBiggerImageModalOpen: false })}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ isBiggerImageModalOpen: false })}>
                    Image
                  </ModalHeader>
                  <ModalBody>
                    <SmartImage src={product.imageUrl} width={500} />
                  </ModalBody>

                  {!isDeleted && (
                    <ModalFooter>
                      <a
                        onClick={() =>
                          this.setState({
                            showImageUploadModal: true,
                            isBiggerImageModalOpen: false,
                          })
                        }
                      >
                        Update
                      </a>
                      <a onClick={() => this.removeThumbnailPhoto(product)}>Remove</a>
                    </ModalFooter>
                  )}
                </Modal>
              </>
            ) : (
              <div
                onClick={() => this.setState({ showImageUploadModal: true })}
                style={{
                  ...this.thumbnailStyle,
                  ...iconStyle,
                  ...imageStyle,
                }}
                className='img-thumbnail'
              >
                <i
                  data-tip
                  data-for='thumbnail-photo-placeholder'
                  style={{
                    ...iconStyle,
                  }}
                  className='image__placeholder__default fa fa-picture-o '
                />
              </div>
            )}

            {!isDeleted && (
              <ImageUploadModal
                isOpen={this.state.showImageUploadModal}
                onHide={() => this.setState({ showImageUploadModal: false })}
                onUpload={(object) => {
                  product.setImageUrl(object.imageUrl)
                  this.setState({ showImageUploadModal: false })
                }}
              />
            )}
          </div>
        </div>
      </>
    )
  }
}
